import { render, staticRenderFns } from "./BusinessPlanTour.vue?vue&type=template&id=419a3516"
import script from "./BusinessPlanTour.vue?vue&type=script&lang=js"
export * from "./BusinessPlanTour.vue?vue&type=script&lang=js"
import style0 from "./BusinessPlanTour.vue?vue&type=style&index=0&id=419a3516&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419a3516')) {
      api.createRecord('419a3516', component.options)
    } else {
      api.reload('419a3516', component.options)
    }
    module.hot.accept("./BusinessPlanTour.vue?vue&type=template&id=419a3516", function () {
      api.rerender('419a3516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/Journal/BusinessPlanTour.vue"
export default component.exports